import { adminSession, getStaffExpiresAt, isTokenExpired } from './session';
import { handleAdminAuthFailure } from './authRealm';

export const handleAuthError = (error) => {
  if (
    error?.response?.data?.message === 'Unauthenticated' ||
    error?.response?.status === 401 ||
    error?.response?.data?.message === 'Token has expired'
  ) {
    logout();
  }
  throw error;
};

export const logout = () => {
  handleAdminAuthFailure();
};

export { isTokenExpired };

export const getAuthHeaders = () => {
  const headers = { Accept: 'application/json' };
  const token = adminSession.getBearerToken();

  if (token) {
    if (isTokenExpired(token)) {
      logout();
      return headers;
    }
    headers.Authorization = `Bearer ${token}`;
  } else if (getStaffExpiresAt() && isTokenExpired()) {
    adminSession.clear();
  }

  return headers;
};
